import { CommonModule } from "@angular/common";
import { ComponentFactoryResolver, NgModule } from "@angular/core";
import { ComponentFactoryService } from "@obg/ngx.ui.core";

import { ExpandableTextComponent } from "./expandable-text.component";

const DIRECTIVES = [ExpandableTextComponent];

@NgModule({
	imports: [CommonModule],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class ExpandableTextModule {
	constructor(componentFactoryService: ComponentFactoryService, resolver: ComponentFactoryResolver) {
		componentFactoryService.registerLazyLoadedResolver(resolver, ...DIRECTIVES);
	}
}
